/**
 * DSLCardLogo
 *
 * Renders a company logo in the top-left corner of a card.
 * The parent div must be position:relative (all card layer divs are).
 *
 * src: full path to the logo file, e.g. '/logos/black-arrow.svg'
 *      Pass null/undefined to render nothing.
 */

export default function DSLCardLogo({ src, width = 48, offsetY = 0 }) {
  if (!src) return null
  return (
    <img
      className="dsl-card-logo"
      src={src}
      alt="company logo"
      draggable={false}
      style={{ width: `${width}px`, '--logo-width': `${width}px`, '--logo-offset-y': `${offsetY}px` }}
    />
  )
}
